import { Button, Table, TableBody, TableContainer, TableHead, TableRow } from "@mui/material";
import TableCellComponent from "components/table/TableCellComponent";
import TableRowComponent from "components/table/TableRowComponent";
import { HEADER_VENDOR_TABLE } from "constants/data";
import { Vendor } from "../types/vendor";
import { getSendPatternText } from "../constants/sendPattern";

interface VendorTableProps {
  vendors: Vendor[];
  openModal: (vendor: Vendor) => void;
}

/**
 * VendorTable component renders a table with vendor details.
 *
 * @param {VendorTableProps} props - The properties for the component.
 * @param {VendorType[]} props.vendors - The list of vendors to display.
 * @returns {JSX.Element} The rendered table component.
 */
export default function TableVendorList({
  vendors,
  openModal,
}: VendorTableProps) {
  return (
    <TableContainer
      component={Table}
      sx={{
        width: "max-content",
        boxShadow: "none",
      }}
    >
      <TableHead>
        <TableRowComponent data={HEADER_VENDOR_TABLE} type="header" />
      </TableHead>
      <TableBody>
        {vendors.map((vendor, index) => (
          <TableRow
            // eslint-disable-next-line react/no-array-index-key
            key={`${vendor.vendor_cd}-${index}`}
            className={index % 2 === 0 ? "even" : "odd"}
          >
            <TableCellComponent>{vendor.vendor_cd}</TableCellComponent>

            <TableCellComponent sx={{ textAlign: "left" }}>
              {vendor.mst_vendor_vendor_name ?? vendor.yh_vendor_name}
            </TableCellComponent>
            <TableCellComponent sx={{ textAlign: "left" }}>
              {getSendPatternText(vendor.send_pattern)}
            </TableCellComponent>
            <TableCellComponent sx={{ textAlign: "left" }}>
              {vendor.mst_vendor_email_address}
            </TableCellComponent>
            <TableCellComponent sx={{ textAlign: "left" }}>
              <Button
                variant="outlined"
                onClick={() => {
                  openModal(vendor);
                }}
                sx={{
                  border: "1px solid var(--gray-250)",
                  backgroundColor: "var(--white)",
                  color: "var(--black)",
                  fontSize: { xs: "16px", md: "18px", xl: "20px" },
                  borderRadius: "4px",
                  width: { xs: "100%", xl: "83%" },
                  height: "40px",
                  whiteSpace: "pre",
                  mt: "16.5px",
                  mb: "11.5px",
                }}
              >
                詳細
              </Button>
            </TableCellComponent>
          </TableRow>
        ))}
      </TableBody>
    </TableContainer>
  );
}
